/**
 * Verona Tempo — round 15: buttons & the filter bar (behaviour).
 *
 *  1. "In stock only" is a real switch. The checkbox carries role="switch"; this keeps aria-checked in step
 *     with it the moment it is tapped, so a screen reader says "In stock only, switch, on" / "…, off" instead
 *     of going quiet until the page redraws. The little "On" / "Off" word beside it is updated at the same time.
 *  2. A short spoken message ("Showing 124 products") after the list has been redrawn, read from the phone
 *     trigger button, so someone using a screen reader hears the result of a filter without hunting for it.
 *  3. Buttons that say they are loading (data-vt-loading) get aria-busy and keep their width, so the page
 *     does not jump while they work.
 *
 *  Loaded on every page (deferred) while Theme settings > Verona Tempo > "Better buttons (round 15)" is on.
 *  Untick that setting and this file is not loaded at all. Styles: assets/vt-r15-buttons.css.
 */
(function () {
  'use strict';
  if (window.vtR15) return;
  window.vtR15 = true;

  /* ---- 1. the "In stock only" switch ------------------------------------------------ */
  function syncSwitch(input) {
    if (!input) return;
    input.setAttribute('aria-checked', input.checked ? 'true' : 'false');
    var label = input.closest('label');
    var state = label && label.querySelector('[data-vt-switch-state]');
    if (state) {
      var word = input.checked ? state.getAttribute('data-on') : state.getAttribute('data-off');
      if (word) state.textContent = word;
    }
  }
  function syncAll(root) {
    (root || document).querySelectorAll('[data-vt-switch]').forEach(syncSwitch);
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-vt-switch]')) syncSwitch(e.target);
  });
  // Space on a role="switch" checkbox already toggles it; this only covers the state being set in code
  document.addEventListener('vt:filterbar:render', function () { syncAll(); });

  /* ---- 2. say how many products are left, once the list has settled ------------------ */
  var live = null;
  function speak(text) {
    if (!text) return;
    if (!live) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    if (live.textContent === text) return;
    live.textContent = text;
  }
  var lastCount = null;
  function announceCount() {
    var el = document.querySelector('[data-vt-trigger-count]');
    if (!el) return;
    var text = el.textContent.trim();
    if (lastCount === null) { lastCount = text; return; } // first paint: nothing to announce
    if (text === lastCount) return;
    lastCount = text;
    speak(text);
  }

  function start() {
    syncAll();
    announceCount();
    var bar = document.querySelector('.vt-ubar[data-ajax-container]');
    if (bar && 'MutationObserver' in window) {
      new MutationObserver(function () { syncAll(); announceCount(); }).observe(bar, { childList: true, subtree: true });
    }

    /* ---- 3. buttons that show they are working ------------------------------------- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-vt-loading]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      var w = btn.getBoundingClientRect().width;
      if (w) btn.style.minWidth = Math.ceil(w) + 'px';
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
